/** @jsx jsx */
import { Button, ShoppingCartIcon } from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function BrandActions({ brand, ...rest }) {
  if (!brand?.onlineShop) return null;
  return (
    <Button
      href={brand.onlineShop}
      target="_blank"
      rel="noopener noreferrer"
      variant="primary"
      sx={{ paddingX: 4, paddingY: 2, alignItems: 'center' }}
      {...rest}
    >
      <ShoppingCartIcon
        size="small"
        sx={{ marginRight: 2, color: 'currentColor' }}
      />
      <Trans>Go to online shop</Trans>
    </Button>
  );
}

export const fragment = graphql`
  fragment BrandActions on AbstractBrand {
    onlineShop
  }
`;
